import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { USERS_AND_PERMISSIONS_MODAL } from './constants'

const UsersAndPermissionsModal = Loadable(() => import('./UsersAndPermissions'))

export const createUsersAndPermissionsNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'key2',
  text: translateFn('cmd_user_sec'),
  identity: USERS_AND_PERMISSIONS_MODAL,
  component: UsersAndPermissionsModal,
}))
